module.exports = __webpack_public_path__ + "static/media/sachi.ce98fe83.jpg";